import { useCallback } from 'react';
import { Layout, PrimaryButton } from "../components/index";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router"
import styled from 'styled-components'

const SignUpComplete = () => {
    const dispatch = useDispatch()

    const goBackToTop = useCallback(() => {
        dispatch(push('/'))
    }, [dispatch])

    return (
        <Layout>
            <section style={{textAlign:'center'}}>
                <div className='spacer-100' />
                <div className='spacer-100' />
                <Paragraph>ご登録いただき、誠にありがとうございます。</Paragraph>
                <Paragraph>引き続きT3のサービスをお楽しみください。</Paragraph>
                <div className='spacer-50' />
                <PrimaryButton label="ストアトップへ" operation={goBackToTop} />
                <div className='spacer-100' />
                <div className='spacer-100' />
            </section>
        </Layout>
    );
};

export default SignUpComplete

const Paragraph = styled.p`
    line-height: 1.7rem;
    letter-spacing: 0.05rem;
`